// extracted by mini-css-extract-plugin
export var hidden = "_u9-0";